/* ==========================================================================
   CD POPUP — tetikleme + zamanlama motoru
   2026 pratigi: aninda gosterme yok. Niyet sinyali bekle, satin almayi kesme.

   Tetikleyiciler (ilk gerceklesen kazanir):
     1. Exit-intent            (yalniz masaustu, imlec viewport ustunden cikinca)
     2. Scroll esigi           (sayfanin %N'i gorulunce)
     3. Zaman esigi            (N saniye, mobil ve exit-intent olmayan durum icin)

   Bastirma kurallari:
     - Ilk sayfa goruntulemede gosterme (oturumda >= N pageview sarti)
     - Sepette urun varsa gosterme (satin alma niyeti kesilmesin)
     - /cart, /checkout, /account, /challenge sayfalarinda gosterme
     - Kayit olana bir daha asla gosterme
     - Kapatana N gun gosterme
     - Ucretli trafikte (utm_source/gclid/fbclid) daha uzun zaman esigi
     - Oturum basina en fazla 1 kez
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-cd-popup]');
  if (!root) return;

  var cfg = JSON.parse(root.getAttribute('data-cd-popup-config') || '{}');

  var KEY_DISMISS = 'cd_popup_dismissed_until';
  var KEY_SUBSCRIBED = 'cd_popup_subscribed';
  var KEY_PAGEVIEWS = 'cd_popup_pageviews';
  var KEY_SESSION_SHOWN = 'cd_popup_shown_session';
  var KEY_REMINDER_OFF = 'cd_popup_reminder_off';

  var panel = root.querySelector('.cd-popup__panel');
  var form = root.querySelector('.cd-popup__form');
  var emailInput = root.querySelector('.cd-popup__field');
  var submitBtn = root.querySelector('.cd-popup__submit');
  var errorEl = root.querySelector('.cd-popup__error');
  var reminder = document.querySelector('[data-cd-popup-reminder]');

  var opened = false;
  var armed = false;
  var timers = [];
  var lastFocus = null;

  /* ---------- depolama yardimcilari (private mode guvenli) ---------- */

  function ls(action, key, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(key);
      if (action === 'set') return window.localStorage.setItem(key, value);
      if (action === 'del') return window.localStorage.removeItem(key);
    } catch (e) {
      return null;
    }
  }

  function ss(action, key, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(key);
      if (action === 'set') return window.sessionStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }

  /* ---------- uygunluk kontrolleri ---------- */

  function isBlockedPath() {
    var p = window.location.pathname;
    return /^\/(cart|checkout|account|challenge|tools|apps|\d+\/checkouts)/.test(p);
  }

  function isPaidTraffic() {
    var qs = window.location.search;
    if (/[?&](utm_source|utm_medium|utm_campaign|gclid|fbclid|ttclid|msclkid)=/i.test(qs)) return true;
    // Oturum boyunca hatirla: ucretli girisin ikinci sayfasinda da gecerli olsun
    if (ss('get', 'cd_paid_session') === '1') return true;
    return false;
  }

  function hasCartItems() {
    // Tema sepet sayaci; yoksa cerezden oku
    var el = document.querySelector('[data-cart-count], .cart-link__bubble-num, .site-header__cart-indicator');
    if (el) {
      var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(n) && n > 0) return true;
    }
    if (window.CD_CART_COUNT && window.CD_CART_COUNT > 0) return true;
    return false;
  }

  function dismissedRecently() {
    var until = parseInt(ls('get', KEY_DISMISS) || '0', 10);
    return until > Date.now();
  }

  function alreadySubscribed() {
    return ls('get', KEY_SUBSCRIBED) === '1';
  }

  function bumpPageviews() {
    var n = parseInt(ss('get', KEY_PAGEVIEWS) || '0', 10) + 1;
    ss('set', KEY_PAGEVIEWS, String(n));
    if (isPaidTraffic()) ss('set', 'cd_paid_session', '1');
    return n;
  }

  function eligible() {
    if (cfg.testMode) return true;
    if (alreadySubscribed()) return false;
    if (dismissedRecently()) return false;
    if (ss('get', KEY_SESSION_SHOWN) === '1') return false;
    if (isBlockedPath()) return false;
    if (cfg.hideWhenCartHasItems && hasCartItems()) return false;
    return true;
  }

  /* ---------- ac / kapat ---------- */

  function open() {
    if (opened || !eligible()) return;
    opened = true;
    clearTimers();

    lastFocus = document.activeElement;
    root.removeAttribute('hidden');
    void root.offsetWidth; // reflow: display:none cikisinda transition calissin
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    ss('set', KEY_SESSION_SHOWN, '1');

    if (reminder) reminder.classList.remove('is-shown');

    // Odagi panele tasi
    window.setTimeout(function () {
      if (emailInput) emailInput.focus({ preventScroll: true });
    }, 380);

    document.addEventListener('keydown', onKeydown);
  }

  function close(persistDismissal) {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);

    if (persistDismissal && !cfg.testMode) {
      var days = parseInt(cfg.dismissDays, 10) || 30;
      ls('set', KEY_DISMISS, String(Date.now() + days * 86400000));
    }

    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    maybeShowReminder();
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      close(true);
      return;
    }
    // Odak tuzagi
    if (e.key === 'Tab' || e.keyCode === 9) {
      var focusables = panel.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* ---------- hatirlatici sekme ---------- */

  function maybeShowReminder() {
    if (!reminder) return;
    if (alreadySubscribed()) return;
    if (ls('get', KEY_REMINDER_OFF) === '1') return;
    reminder.classList.add('is-active');
    window.setTimeout(function () {
      reminder.classList.add('is-shown');
    }, 600);
  }

  /* ---------- tetikleyiciler ---------- */

  function clearTimers() {
    timers.forEach(function (t) { window.clearTimeout(t); });
    timers = [];
    document.removeEventListener('mouseout', onExitIntent);
    window.removeEventListener('scroll', onScroll);
  }

  function onExitIntent(e) {
    if (opened) return;
    // Imlec viewport ustunden cikti mi (sekme kapatma / adres cubugu yonu)
    if (e.clientY > 0) return;
    if (e.relatedTarget || e.toElement) return;
    open();
  }

  function onScroll() {
    if (opened) return;
    var doc = document.documentElement;
    var scrolled = (window.pageYOffset || doc.scrollTop);
    var height = (doc.scrollHeight - window.innerHeight);
    if (height <= 0) return;
    var pct = (scrolled / height) * 100;
    if (pct >= (parseInt(cfg.scrollPercent, 10) || 35)) open();
  }

  function arm() {
    if (armed) return;
    armed = true;

    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    var seconds = parseInt(cfg.delaySeconds, 10) || 25;

    // Ucretli trafikte daha sabirli ol: erken pop-up bounce'u pahaliya patlar
    if (isPaidTraffic()) {
      seconds = Math.max(seconds, parseInt(cfg.paidDelaySeconds, 10) || 40);
    }

    // 1. Exit-intent — yalniz masaustu (mobilde mouseout yok)
    if (isDesktop && cfg.enableExitIntent) {
      document.addEventListener('mouseout', onExitIntent);
    }

    // 2. Scroll esigi
    if (cfg.enableScroll) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // 3. Zaman esigi
    if (cfg.enableTimer) {
      timers.push(window.setTimeout(open, seconds * 1000));
    }
  }

  /* ---------- form gonderimi ---------- */

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.classList.add('is-visible');
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.classList.remove('is-visible');
  }

  function markSubscribed() {
    ls('set', KEY_SUBSCRIBED, '1');
    ls('del', KEY_DISMISS);
    ls('set', KEY_REMINDER_OFF, '1');
    if (reminder) reminder.classList.remove('is-active', 'is-shown');
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var email = (emailInput && emailInput.value || '').trim();
      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
        showError(cfg.errorInvalid || 'Gecerli bir e-posta adresi girin.');
        if (emailInput) emailInput.focus();
        return;
      }

      submitBtn.setAttribute('disabled', 'disabled');
      var originalLabel = submitBtn.textContent;
      submitBtn.textContent = cfg.sendingLabel || 'GONDERILIYOR';

      var data = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          // Shopify hata durumunda form hatalarini HTML icinde dondurur
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var err = doc.querySelector('.errors, .form-message--error, #NewsletterPopupError');

          if (err && err.textContent.trim()) {
            showError(err.textContent.trim());
            submitBtn.removeAttribute('disabled');
            submitBtn.textContent = originalLabel;
            return;
          }

          markSubscribed();
          root.classList.add('is-success');

          if (window.dataLayer) {
            window.dataLayer.push({ event: 'cd_popup_signup', method: 'theme_popup' });
          }

          if (cfg.autoCloseAfterSuccess) {
            timers.push(window.setTimeout(function () { close(false); }, 6000));
          }
        })
        .catch(function () {
          // Ag hatasi: klasik form gonderimine dus (sayfa yenilenir ama kayit kaybolmaz)
          form.setAttribute('data-cd-native-submit', '1');
          HTMLFormElement.prototype.submit.call(form);
        });
    });
  }

  /* ---------- olay baglari ---------- */

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-popup-close]') || e.target.classList.contains('cd-popup__overlay')) {
      close(true);
    }
  });

  if (reminder) {
    reminder.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-popup-reminder-close]')) {
        e.stopPropagation();
        ls('set', KEY_REMINDER_OFF, '1');
        reminder.classList.remove('is-shown');
        window.setTimeout(function () { reminder.classList.remove('is-active'); }, 400);
        return;
      }
      // Sekmeye tiklayinca pop-up'i zorla ac
      opened = false;
      root.removeAttribute('hidden');
      void root.offsetWidth;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      opened = true;
      document.addEventListener('keydown', onKeydown);
      reminder.classList.remove('is-shown');
      if (emailInput) window.setTimeout(function () { emailInput.focus(); }, 380);
    });
  }

  /* ---------- baslat ---------- */

  function init() {
    var pageviews = bumpPageviews();

    // Tema editorunde her zaman goster
    if (cfg.testMode) {
      open();
      return;
    }

    if (!eligible()) {
      maybeShowReminder();
      return;
    }

    // Ilk sayfa goruntulemede gosterme: niyet sinyali olussun
    var minViews = parseInt(cfg.minPageviews, 10) || 2;
    if (pageviews < minViews) {
      maybeShowReminder();
      return;
    }

    arm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
